const runtime = (typeof window !== 'undefined' && window.__ENV__) || {}

export default {
  url: runtime.URL || "https://api.flowsimulationgame.com",
  apiUrl: runtime.API_URL || "https://api.flowsimulationgame.com/api/v1",
  filesUrl: runtime.FILES_URL || "https://api.flowsimulationgame.com/api/files/",
  debug: runtime.DEBUG === "true" || false
}
